import {Deserializable} from './deserializable';


export class SerialsList implements Deserializable {

  devices: string[] = [];

  deserialize(input: any) {
    
    Object.assign(this, input);
    return this;
  }
}
